export enum ButtonTypeEnum {
  PRIMARY = 'btn_primary',
  SECONDARY = 'btn_secondary',
  DISABLED = 'btn_disabled',
  DISABLED_OUTLINE = 'btn_disabled_outline',
  PRIMARY_OUTLINE = 'btn_primary_outline',
  SECONDARY_OUTLINE = 'btn_secondary_outline',
  DANGER = 'btn_danger_outline',
  LIGHT = 'btn_light',
  LIGHT_DANGER = 'btn_light_danger'
}

export enum ButtonSizeEnum {
  LG = 'btn_lg',
  MD = 'btn_md',
  SM = 'btn_sm'
}
